import React, { Fragment } from "react";
import { ContentPanel, DisplayBox, QuarterGrid } from "components/containers";
import { ListBuilder, DataList, Format } from "@redriver/cinnamon";
import { getItineraryList } from "./actions";
import { Button } from "semantic-ui-react";
import { ResortRepItineraryType } from "constants/enums";
import useSkiSeasonDates from "modules/useSkiSeasonDates";

const TravelDetailsPanel = () => {
  const skiSeasonDates = useSkiSeasonDates();
  return (
    <ContentPanel title="Travel Details" className="itinerary-details">
      <ListBuilder
        loadAction={getItineraryList}
        loadParams={{
          departureDateFrom: skiSeasonDates.start.toISOString(),
          departureDateTo: skiSeasonDates.end.toISOString(),
        }}
        initialPagination={{
          pageSize: 10,
          pageNumber: 1,
        }}
        totalTransform={(x) => x.totalResults}
        dataTransform={(x) => x.results}
        renderList={(data, state, events) => (
          <div>
            {data.length == 0 && <p>No travel found.</p>}
            {data.map((x) => (
              <TravelBox item={x} key={x.id} />
            ))}

            {state.hasMore && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  primary
                  size="small"
                  loading={state.loadingMore}
                  onClick={events.onLoadMore}
                >
                  Load More
                </Button>
              </div>
            )}
          </div>
        )}
      />
    </ContentPanel>
  );
};

const TravelBox = ({ item }) => {
  return (
    <DisplayBox
      className="travel-box"
      title={
        <span>
          {item.type == ResortRepItineraryType.Accommodation && "Accommodation"}
          {item.type == ResortRepItineraryType.Travel && "Travel"}
        </span>
      }
    >
      <QuarterGrid as={DataList}>
        {item.type == ResortRepItineraryType.Accommodation && (
          <Fragment>
            <DataList.Item title="Supplier">{item.supplier}</DataList.Item>
            <DataList.Item title="Destination">
              {item.destination}
            </DataList.Item>
            <DataList.Item title="Arrival Date/Time">
              <Format.Date value={item.dateFrom} format="dddd D MMMM YYYY" />
              {item.timeFrom ? ` - ${item.timeFrom}` : ""}
            </DataList.Item>
            <DataList.Item title="Departure Date/Time">
              <Format.Date value={item.dateTo} format="dddd D MMMM YYYY" />
              {item.timeTo ? ` - ${item.timeTo}` : ""}
            </DataList.Item>
          </Fragment>
        )}
        {item.type == ResortRepItineraryType.Travel && (
          <Fragment>
            <DataList.Item title="Departure Date/Time">
              <Format.Date value={item.dateFrom} format="dddd D MMMM YYYY" />
              {item.timeFrom ? ` - ${item.timeFrom}` : ""}
            </DataList.Item>
            <DataList.Item title="Departure Location">
              {item.departureLocation}
            </DataList.Item>
            <DataList.Item title="Arrival Date/Time">
              <Format.Date value={item.dateTo} format="dddd D MMMM YYYY" />
              {item.timeTo ? ` - ${item.timeTo}` : ""}
            </DataList.Item>
            <DataList.Item title="Arrival Location">
              {item.arrivalLocation}
            </DataList.Item>
          </Fragment>
        )}
      </QuarterGrid>
      <DataList>
        <DataList.Item title="Comments">{item.comments}</DataList.Item>
      </DataList>
    </DisplayBox>
  );
};

export default TravelDetailsPanel;
